import React from 'react';
import { IonButton, IonSpinner, IonIcon } from '@ionic/react';
import { checkmarkCircleOutline } from 'ionicons/icons';
import { pxToRem } from '@/modules/config';

interface CreateFooterProps {
  endBeforeStart: boolean;
  saving: boolean;
  topicTitle: string;
  canCreateTopics: boolean;
  onCreate: () => void;
}

/** The create-mode footer: submit button + end-before-start / permission notices. */
const CreateFooter: React.FC<CreateFooterProps> = ({
  endBeforeStart,
  saving,
  topicTitle,
  canCreateTopics,
  onCreate,
}) => (
  <>
    {endBeforeStart && (
      <p
        style={{
          fontSize: pxToRem(12),
          color: 'var(--ion-color-danger)',
          margin: '0 4px 12px',
        }}
      >
        End time must be after start time.
      </p>
    )}

    <div style={{ marginTop: '4px', padding: '0 4px' }}>
      <IonButton
        expand="block"
        onClick={onCreate}
        disabled={saving || !topicTitle.trim() || endBeforeStart}
        color="primary"
      >
        {saving ? (
          <IonSpinner name="crescent" />
        ) : (
          <IonIcon icon={checkmarkCircleOutline} slot="start" />
        )}
        {saving ? 'Creating...' : 'Create Topic'}
      </IonButton>
    </div>

    {!canCreateTopics && (
      <p
        style={{
          fontSize: pxToRem(12),
          color: '#666',
          textAlign: 'center',
          marginTop: '10px',
        }}
      >
        Your role does not have permission to create topics
      </p>
    )}
  </>
);

export default CreateFooter;
